export const STEP = {
    QUESTION: "question",
    ANSWER: "answer",
    PARAMS: "params",
};
